import React, { useEffect, useRef, useState } from "react";
import AlertField from "../Components/AlertField";
import BlogCard from "../Components/BlogCard";
import Paginate from "../Components/Paginate";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import axios from "../shared";
import useAuth from "../Hooks/useAuth";

const BlogList = () => {
  const { auth } = useAuth();
  const [alert, setAlert] = useState(null);
  const [values, setValues] = useState({});
  const [pageCount, setpageCount] = useState(0);
  const [count, setCount] = useState(0);
  const [endValue, setEndValue] = useState(0);
  const [startValue, setStartValue] = useState(1);
  const [cancelTitle, setCancelTitle] = useState(false);
  const [cancelCategory, setCancelCategory] = useState(false);
  const [category, setCategory] = useState([]);
  const searchRef = useRef(null);
  const axiosPrivate = useAxiosPrivate();
  const limit = 5;

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  useEffect(() => {
    const url = `blog/?limit=${limit}`;
    fetchData(url);

    //gets the list of category
    const getCategory = async () => {
      const response = await axios.get("blog/doctor/category");
      setCategory(response.data);
    };

    getCategory();
  }, []);

  const fetchData = async (url) => {
    try {
      var response;
      if (auth.length > 0) {
        response = await axiosPrivate.get(url);
      } else {
        response = await axios.get(url);
      }
      //sets the list of data got from api
      setValues(response?.data.results);
      //gets the total record and divides by 5 to set pagination number
      setpageCount(Math.ceil(response.data.count / 5));
      //sets the total number of record to display in bottom message
      setCount(response?.data.count);
      //sets the start and end value as length of records got
      setStartValue(1);
      setEndValue(response?.data.results.length);
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else {
        showAlert("Load Failed", "warning");
      }
    }
  };

  const getBlogs = async (url) => {
    var response;
    if (auth.length > 0) {
      response = await axiosPrivate.get(url);
    } else {
      response = await axios.get(url);
    }
    return response;
  };

  const handlePageClick = async (data) => {
    let currentPage = data.selected * limit;

    const url = `blog/?limit=${limit}&offset=${currentPage}`;

    //calls the api with limit and currentpage as offset and get response data
    const response = await getBlogs(url);

    //sets response into list
    setValues(response?.data.results);
    //sets start and end value
    setStartValue(data.selected * limit + 1);
    setEndValue(data.selected * limit + response?.data.results.length);

    if (response?.data.results.length === 0) {
      setStartValue(0);
      setEndValue(0);
    }
  };

  const searchCategory = async (e) => {
    const url = `blog/?limit=${limit}&category=${e.target.value}`;

    fetchData(url);
    setCancelCategory(true);
    setCancelTitle(false);
  };

  const search = async (e) => {
    if (e.key === "Enter") {
      //replaces white space with %20
      const title = e.target.value.replace(/\s/g, "%20");

      const url = `blog/?limit=${limit}&title=${title}`;
      await fetchData(url);

      //activates the reset filter button
      setCancelTitle(true);
      setCancelCategory(false);
    }
  };

  const onCancel = () => {
    //deactivates the reset filter button
    setCancelCategory(false);
    setCancelTitle(false);
    searchRef.current.value = "";
    const url = `blog/?limit=${limit}`;
    fetchData(url);
  };

  const onDelete = async (id) => {
    try {
      await axiosPrivate.delete(`blog/${id}/`);
      fetchData(`blog/?limit=${limit}`);
      showAlert("Blog Deleted.", "success");
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response.", "warning");
      } else {
        showAlert("Delete Failed.", "warning");
      }
    }

    //closes the modal form
    document.getElementById(`confirmationModal${id}-close`).click();
  };

  return (
    <div>
      <AlertField alert={alert} />
      <h2 className="text-center py-2 mb-4">Blogs</h2>
      <div className="w-100 row row-cols-1 row-cols-md-2 flex-column-reverse flex-md-row m-0 px-md-5 px-4 justify-content-between">
        <div className="col">
          {values?.length > 0 ? (
            values?.map((values, i) => (
              <BlogCard values={values} key={i} onDelete={onDelete} />
            ))
          ) : (
            <h2 className="text-center py-2 mb-4">No Blogs</h2>
          )}

          <Paginate
            startValue={startValue}
            endValue={endValue}
            count={count}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />
        </div>
        <div className="text-md-end mb-4 position-relative">
          <div className="sticky-top" style={{ top: 9 + "rem" }}>
            <input
              className="rounded p-1 w-auto"
              type="text"
              id="search"
              name="search"
              placeholder="Type Title and Press Enter"
              onKeyUp={search}
              ref={searchRef}
            />
            {cancelTitle && (
              <button
                className="ms-1 ms-md-4 btn btn-primary"
                onClick={onCancel}
              >
                <i className="fa-solid fa-xmark p-1"></i>
              </button>
            )}

            <div className="mt-md-3 mt-2">
              <div className="ms-md-5 mb-2 mb-md-4 text-center">
                <h4 className="d-inline text-center">Available Categories</h4>
                {cancelCategory && (
                  <button className="ms-4 btn btn-primary" onClick={onCancel}>
                    <i className="fa-solid fa-xmark p-1"></i>
                  </button>
                )}
              </div>

              <div className="ms-md-5 row px-md-5 justify-content-between">
                {category.length ? (
                  category?.map((category, i) => (
                    <button
                      className="btn btn-outline-dark text-capitalize w-auto mx-md-5 my-2"
                      key={i}
                      value={category}
                      onClick={searchCategory}
                    >
                      {category}
                    </button>
                  ))
                ) : (
                  <p className="text-center w-100">No Categories</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogList;
